import WavyBackground from '@gc-bridge/assets/images/wavy-background_shared.png';
import { LinkButton } from '@gc-bridge/components/Button/Link';
import { CenteredContainer } from '@gc-bridge/components/Container/Centered';
import { AdditionalColors } from '@gc-bridge/theme/colors';
import { BuildCircleOutlined } from '@mui/icons-material';
import { Box, Typography } from '@mui/material';

interface Props {
  remoteAppName: string;
}

export function Maintenance({ remoteAppName }: Props) {
  return (
    <CenteredContainer backgroundImage={WavyBackground}>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          gap: '5px',
        }}
      >
        <BuildCircleOutlined fontSize="large" color="secondary" />
        <Typography fontSize="32px" color="text.primary" lineHeight="35px">
          Maintenance Mode
        </Typography>
      </Box>
      <Typography
        fontSize="18px"
        color={AdditionalColors.BlackOpacity50}
        maxWidth="60%"
        textAlign="center"
      >
        {remoteAppName} is currently performing scheduled maintenance and will be back
        online shortly. <br /> You can still browse GC Bridge. Thank you for your
        patience.
      </Typography>
      <LinkButton label="Back to Bridge" url="/" />
    </CenteredContainer>
  );
}
